import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	routes: [
		 //MAINTENANCE MODE
		//{
		//	path: '/*',
		//	name: 'maintenance',
		//	meta: 'register',
		//	alias: 'maintenance',
		//	component: () => import('./components/MaintenanceMode.vue')
		//},
		// Entry point routes

		// REGISTRATION LINKS
		{
			path: '/register',
			name: 'register',
			meta: 'register',
			alias: 'register',
			props: true,
			component: () => import('./components/Register.vue')
		},
		{
			path: '/partner',
			name: 'register_partner',
			meta: 'register',
			alias: 'register_partner',
			props: true,
			component: () => import('./components/Register.vue')
		},
		{
			path: '/customer/',
			name: 'register_customer',
			meta: 'register',
			alias: 'register_customer',
			props: true,
			component: () => import('./components/RegisterCustomer.vue')
		},
		{
			path: '/',
			name: 'login',
			meta: 'login',
			alias: '/login',
			component: () => import('./components/Login.vue')
			
		},
		{
			path: '/email',
			name: 'email',
			meta: 'login',
			alias: '/email',
			component: () => import('./components/Emailconf.vue')
			
		},
		{
			path: '/reject',
			name: 'reject',
			meta: 'login',
			alias: '/reject',
			component: () => import('./components/Emailreject.vue')
			
		},
		{
			path: '/emailnotverified',
			name: 'emailnotverified',
			meta: 'register',
			alias: '/emailnotverified',
			component: () => import('./components/Emailnotverified.vue')
			
		},
		{
			path: '/forgotpassword',
			name: 'forgotpassword',
			meta: 'login',
			alias: 'forgotpassword',
			component: () => import('./components/Forgotpassword.vue')

		},
		{
			path: '/changepassword',
			name: 'changepassword',
			meta: 'login',
			alias: 'changepassword',
			component: () => import('./components/Changepassword.vue')

		},
		// User routes
		{
			path: '/user/profile',
			name: 'profile',
			meta: 'user',
			component: () => import('./components/user/Profile.vue')
		},
		{
			path: '/user/kyc',
			name: 'user_kyc',
			meta: 'user',
			component: () => import('./components/user/Kyc.vue')
		},
		{
			path: '/user/financial',
			name: 'user_financial',
			meta: 'user',
			component: () => import('./components/user/Financial.vue')
        },
        {
            path: '/user/contacts',
            name: 'user_contacts',
            meta: 'user',
            component: () => import('./components/user/Contacts.vue')
        },
		{
			path: '/user/welcome',
			name: 'user_welcome',
			meta: 'user',
			component: () => import('./components/user/Welcome.vue')
		},
        {
            path: '/user/overview',
            name: 'user_overview',
            meta: 'user',
            component: () => import('./components/user/Overview.vue')
		},
		{
			path: '/user/purchases',
			name: 'user_purchases',
			meta: 'user',
			component: () => import('./components/user/Purchases.vue')
        },
        {
            path: '/user/commissions',
            name: 'user_commissions',
            meta: 'user',
            component: () => import('./components/user/Commissions.vue')
        },
        {
            path: '/user/payouts',
            name: 'user_payouts',
            meta: 'user',
            component: () => import('./components/user/Payouts.vue')
        },
        {
            path: '/user/news/:id',
            name: 'user_news',
            meta: 'user',
            component: () => import('./components/user/News.vue'),
            props: true
        },
		{
			path: '/user/accountsummary',
			name: 'user_accountsummary',
			meta: 'user',
			component: () => import('./components/user/AccountSummary.vue'),
			props: true
		},
		// Admin routes
		{
			path: '/admin',
			name: 'overview',
			meta: 'admin',
			component: () => import('./components/admin/Overview.vue')
		},
		{
			path: '/admin/kyc/:status',
			name: 'kyc',
			meta: 'admin',
			props: true,
			component: () => import('./components/admin/Kyc.vue')
        },
		{
			path: '/admin/members',
			name: 'members',
			meta: 'admin',
			component: () => import('./components/admin/Members.vue')
		},
		{
			path: '/admin/reports/purchases',
			name: 'reports-purchases',
			meta: 'admin',
			component: () => import('./components/admin/reports/Purchases.vue'),
			props: true
        },
        {
            path: '/admin/reports/turnover',
            name: 'reports-turnover',
            meta: 'admin',
            component: () => import('./components/admin/reports/Turnover.vue'),
            props: true
        },
		{
			path: '/admin/reports/btcpurchases',
			name: 'reports-btcpurchases',
			meta: 'admin',
			component: () => import('./components/admin/reports/BTCPurchases.vue'),
			props: true
		},		
		{
			path: '/admin/reports/btctransactions',
			name: 'reports-btctransactions',
			meta: 'admin',
			component: () => import('./components/admin/reports/BTCTransactions.vue'),
			props: true
		},
		{
			path: '/admin/reports/invoices',
			name: 'reports-invoices',
			meta: 'admin',
			component: () => import('./components/admin/reports/Invoices.vue'),
			props: true
		},		
		
        {
            path: '/admin/commissions',
            name: 'commissions',
            meta: 'admin',
            component: () => import('./components/admin/Commissions.vue'),
            props: true
        },
		{
			path: '/admin/network',
			name: 'network',
			meta: 'admin',
            component: () => import('./components/admin/Placeholder.vue'),
			props: true
        },
        {
            path: '/admin/news',
            name: 'news',
            meta: 'admin',
            component: () => import('./components/admin/News.vue'),
            props: true
        },
        {
            path: '/user/shop',
            name: 'shop',
            meta: 'admin',
            component: () => import('./components/user/Shop.vue')
        },
        {
            path: '/user/payment',
            name: 'payment',
            meta: 'admin',
            component: () => import('./components/user/Payment.vue')
		},
		{
			path: '/user/payment_confirm',
			name: 'payment_confirm',
			meta: 'user',
			component: () => import('./components/user/PaymentConfirm.vue'),
			props: true
		},
		{
			path: '/user/cc/payment_success',
			name: 'cc_payment_success',
			meta: 'user',
			component: () => import('./components/user/PaymentProcessorSuccess.vue'),
			props: true
		},
		{
			path: '/user/cc/payment_fail',
			name: 'cc_payment_fail',
			meta: 'user',
			component: () => import('./components/user/PaymentProcessorFail.vue'),
			props: true
		},
		{
			path: '/admin/payouts',
            name: 'payouts',
			meta: 'admin',
			component: () => import('./components/admin/Payouts.vue')
        },
        {
            path: '/admin/settings',
            name: 'settings',
            meta: 'admin',
            component: () => import('./components/admin/Placeholder.vue'),
            props: true
        },
        {
            path: '/admin/settings/levels',
            name: 'levels',
            meta: 'admin',
            component: () => import('./components/admin/settings/Levels.vue'),
            props: true
        },
        {
            path: '/admin/settings/packages',
            name: 'packages',
            meta: 'admin',
            component: () => import('./components/admin/settings/Packages.vue'),
            props: true
		},
	
		
		{
			path: '/admin/voucher',
			name: 'voucher',
			meta: 'admin',
			component: () => import('./components/admin/Voucher.vue')
		},
		{
			path: '/admin/documents/:category',
			name: 'documents',
			meta: 'admin',
			props: true,
			component: () => import('./components/admin/Documents.vue')
		},
	
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});